import classes from "./MealsSummary.module.css";

const MealsSummary = () => {
  return (
    <section className={classes.summary}>
      <h2>Wellcome 😊</h2>
      <p>Choose your favorite menu and enjoy the taste at home.</p>
      <p>
        Our menu are made with high-quality ingredients and of course friendly
        pocket price 😂
      </p>
    </section>
  );
};

export default MealsSummary;
